<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <Alerts />
    <PasswordRecoverModal v-if="modal.recover" />
  </div>
</template>

<script setup>
import { useModalStore } from '~/stores/modal'
const modal = useModalStore()
</script>
<style>
html, body {
  min-height: 100vh;
  overflow-x: hidden;
  overscroll-behavior: none;
  background-color: #061222;
  scrollbar-width: none; 
  -ms-overflow-style: none; 
}

html::-webkit-scrollbar, body::-webkit-scrollbar {
  display: none;
}
</style>